import React, { useEffect, useState } from 'react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 w-full z-[100] transition-all duration-300 ${scrolled ? 'bg-brand-dark/90 backdrop-blur-[12px] border-b border-brand-gold/15 py-4' : 'bg-transparent py-6'}`} data-id="element-152">
      <div className="max-w-7xl mx-auto px-5 flex justify-between items-center" data-id="element-153">
        <a href="#" className="font-display text-[22px] tracking-[0.15em] text-brand-cream flex items-center" data-id="element-154">
          REN<span className="text-brand-goldBright" data-id="element-155">A</span>CER
        </a>
        <a href="#producto" className="bg-brand-gold text-brand-dark font-body text-[13px] font-medium rounded-[40px] py-[10px] px-[22px] transition-all duration-300 hover:bg-brand-goldBright hover:-translate-y-[1px]" data-id="element-156">
          Obtener el Protocolo &rarr;
        </a>
      </div>
    </nav>;
}